/**
 * Widget-level design tokens.
 *
 * For Tailwind classes, use semantic tokens directly (primary-*, neutral-*, etc.).
 * This file provides hex values for charts / SVG / canvas / AG-Charts (can't use
 * Tailwind classes). Higher-level tokens and builder functions live in chartTheme.ts.
 */

// ---------------------------------------------------------------------------
// Chart color palette — hex values matching tailwind.config.js semantic tokens
// ---------------------------------------------------------------------------

/**
 * Semantic series colors (the chart design system's rule: color is never
 * decorative). Pick by MEANING, not by palette position:
 *   subject    — the ticker under analysis
 *   benchmark  — index / comparison series, and "positive"
 *   risk       — negative / risk series
 *   caution    — derived or secondary measures (spread, correlation, alerts)
 *   consensus  — neutral reference (sector avg, consensus line)
 */
export const SEMANTIC_CHART_COLORS = {
  subject: '#3b82f6',
  benchmark: '#22c55e',
  risk: '#ef4444',
  caution: '#FFB300',
  consensusDark: '#e5e7eb',
  consensusLight: '#374151',
  series6: '#a855f7', // purple
  series7: '#06b6d4', // teal
  series8: '#f97316', // orange
} as const;

/** Default series color sequence for multi-series charts (semantic order:
 *  subject, benchmark, risk, caution, then the extras). */
export const CHART_SERIES_COLORS = [
  SEMANTIC_CHART_COLORS.subject,
  SEMANTIC_CHART_COLORS.benchmark,
  SEMANTIC_CHART_COLORS.risk,
  SEMANTIC_CHART_COLORS.caution,
  SEMANTIC_CHART_COLORS.series6,
  SEMANTIC_CHART_COLORS.series7,
] as const;
